import ModalCloseCrossIcon from './ModalCloseCrossIcon';

export default ModalCloseCrossIcon;
